import { render } from "./PR25-04242023.vue?vue&type=template&id=89108904"
import script from "./PR25-04242023.vue?vue&type=script&lang=js"
export * from "./PR25-04242023.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__